import type { KnownCommandGroupId } from "../../../services/commands/commands.types";

/** Copy for the command palette and the shortcuts sheet (sentence case, neutral). */
export const COMMAND_PALETTE_COPY = {
  title: "Search and commands",
  placeholder: "Search actions or describe a change",
  empty: "No matching actions",
  close: "Close",
  shortcutsTitle: "Keyboard shortcuts",
  characterKeys: "Single-key shortcuts",
  characterKeysDescription: "Shortcuts that use one key and no modifier, such as ?.",
  paletteGroup: "In the actions list",
  gridGroup: "On story tiles",
  moveThroughResults: "Move through results",
  run: "Run",
  runShort: "run",
  closeHint: "Close",
  freeTextGroup: "Ask MagicBI",
  voice: "voice",
  voiceListening: "Listening",
  allShortcuts: "all shortcuts",
  moveShort: "move",
  storiesGroup: "Stories",
  fieldsGroup: "Fields",
  filterHint: "Add a filter from the Filters bar on",
  storiesHint: "Story",
  storiesUpdated: "updated",
  fieldsHint: "Field",
  freeTextFailed: "Couldn't apply that change.",
  freeTextRow: "Ask",
} as const;

/** Headings of the known groups, in the order they are listed. Other groups use `commandGroupLabel`. */
export const COMMAND_GROUPS: readonly { id: KnownCommandGroupId; label: string }[] = [
  { id: "story", label: "Commands" },
  { id: "history", label: "History" },
  { id: "assistant", label: "Ask MagicBI" },
  { id: "navigation", label: "Navigate" },
  { id: "help", label: "Help" },
];
